<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import tableheader from "../tableheader/index";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Atanan Talepler",
    meta: [
      {
        name: "description", 
        content: appConfig.description, 
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
     treeselect,tableheader
  },
  data() {
    return {
      title: "Atanan Talepler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Atanan Talepler",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      Filter: {
        OrderBy: "Desc=Takipno",
        Atananbirimid: null,
        Durumid: null,
        Oncelikid: null,
        Atananpersonelid: null,
        Personelatanma: false,
        Tahminibitis: null,
        Tahminibitisdurum: null,
        Takipno: null,
        Uygulamaid: null,
        Baslik:null,
        Aciklama:null,
        Tamamlananharic:true,
        Ucretli: null,
      }
    };
  },

  methods: {
    Get() { 
      var Filter = "&" + this.Filter.OrderBy

      if (this.Filter.Baslik != null && this.Filter.Baslik != ""  && 
      typeof this.Filter.Baslik === "string" && this.Filter.Baslik.length > 2) {
        Filter += "&Baslik=" + this.Filter.Baslik
      }
      if (this.Filter.Aciklama != null && this.Filter.Aciklama != "" && 
      typeof this.Filter.Aciklama === "string" && this.Filter.Aciklama.length > 2) {
        Filter += "&Aciklama=" + this.Filter.Aciklama
      }

      if (this.Filter.Ucretli != null && this.Filter.Ucretli != "") {
        Filter += "&Ucretli=" + this.Filter.Ucretli
      }
      if (this.Filter.Uygulamaid != null && this.Filter.Uygulamaid != "") {
        Filter += "&Uygulamaid=" + this.Filter.Uygulamaid
      }
      if (this.Filter.Takipno != null && this.Filter.Takipno != "") {
        Filter += "&Takipno=" + this.Filter.Takipno
      }
 
      if (this.Filter.Durumid != null && this.Filter.Durumid != "") {
        Filter += "&Durumid=" + this.Filter.Durumid
      }
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        Filter += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Tahminibitis != null && this.Filter.Tahminibitis != "") {
        Filter += "&Tahminibitis=" + this.Filter.Tahminibitis
      }
      if (this.Filter.Tahminibitisdurum != null && this.Filter.Tahminibitisdurum != "") {
        Filter += "&Tahminibitisdurum=" + this.Filter.Tahminibitisdurum
      }
      if (this.Filter.Tamamlananharic != null && this.Filter.Tamamlananharic != "") {
        Filter += "&Tamamlananharic=" + this.Filter.Tamamlananharic
      }

      
     
        Filter += "&Atananpersonelid=" + this.TokenPersonelId
   
     
          this.ActionsFilterGet({
            Service: "tlptalep",
            Page: this.Page,
            Filter: Filter,
          }).then((res) => {
            this.TableData = res.Data;
            this.Page.PageDataSize = res.TotalCount;
            this.loading = false;
          });
     
     
    },
    goToDetailPage(Id) { 
        const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
        window.open(routeData.href, '_blank'); 
    },
    
    HarcananZaman(Data){  
       this.Update("tlptalep", Data)
    },
    Guncelle(Data){
      Data.Lastmodifiedby = this.TokenUserId
      Data.Atananbirimid = null
      Data.Durumid =  this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '3').id;
       this.Update("tlptalep", Data)
    },
    Islemde(Data){
      
      Data.Lastmodifiedby = this.TokenUserId 
      Data.Durumid =  this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '4').id;
       this.Update("tlptalep", Data)
    },
    getRowClass(tahminibitis) {
      if (!tahminibitis) return '';

      const today = new Date();
      const dateToCheck = new Date(tahminibitis);
      const diffInDays = (dateToCheck - today) / (1000 * 60 * 60 * 24);

      if (diffInDays <= 0) {
        return 'table-danger';  
      } else if (diffInDays <= 7) {
        return 'table-warning'; 
      } else if (diffInDays <= 30) {
        return 'table-info';  
      } else {
        return '';  
      }
    },
    BirimeIade(Data){

      Data.Durumid =  this.FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '2').id;
      Data.Atananpersonelid = null
      Data.Lastmodifiedby = this.TokenUserId 
       this.Update("tlptalep", Data)
    }

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"> 
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3"  >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">
 
                        <b-form-group class="col-lg-3" label="Takip Numarası"  >
                            <b-form-input  v-model="Filter.Takipno"   type="number"  ></b-form-input> 
                            </b-form-group>


                            <b-form-group class="col-lg-3" label="Başlık"  >
                            <b-form-input  v-model="Filter.Baslik"   type="text"  ></b-form-input> 
                            </b-form-group>
                          <b-form-group class="col-lg-3" label="Açıklama"  >
                            <b-form-input  v-model="Filter.Aciklama"   type="text"  ></b-form-input> 
                            </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Durumid.FieldTitle"
                          :key="Filter.Durumid">
                          <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Durumid" />
                          <treeselect-value :value="Filter.Durumid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>
                        <b-form-group class="col-lg-3" label-for="text" v-if="APPLICATION_TYPE == 1"
                          :label="FormDataType.Uygulamaid.FieldTitle" :key="Filter.Uygulamaid">
                          <treeselect :multiple="false" :options="FormDataType.Uygulamaid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Uygulamaid" />
                          <treeselect-value :value="Filter.Uygulamaid" />
                        </b-form-group>

                    
                        <b-form-group class="col-lg-3" label="Tahmini Bitiş Tarihi"  >
      <b-form-input  v-model="Filter.Tahminibitis"   type="date"  ></b-form-input>
  
      </b-form-group>

      
                        <b-form-group class="col-lg-3" label-for="text" label="Tahmini Bitiş" >
                          <treeselect :multiple="false" :options="[{id: 'esit', label: 'Eşit'},{id: 'kucuk', label: 'Küçük'},{id: 'buyuk', label: 'Büyük'}]"
                            placeholder="Seçiniz..." v-model="Filter.Tahminibitisdurum" /> 
                        </b-form-group>

                           <b-form-group  class="col-lg-1" v-if="APPLICATION_TYPE == 1"
                              label="Ücretli" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Ucretli" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>

                            
                            <b-form-group  class="col-lg-2"
                              label="Tamamlananalar Hariç" 
                            >
                              <b-form-checkbox 
                                value="true" 
                                v-model="Filter.Tamamlananharic" 
                                plain
                              ></b-form-checkbox> 
                            </b-form-group>



 
                        <div class="col-lg-4">
                          <button class="btn btn-success mt-1" data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Get()">
                            Filtreleme
                          </button>
                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
  <h5>Renk Anlamları</h5>
  <div class="d-flex flex-wrap gap-3 ">
    <span class="badge bg-danger p-3">Geçmiş Tarih (Kırmızı)</span>
    <span class="badge bg-warning text-dark p-3">7 Gün İçinde (Turuncu)</span>
    <span class="badge bg-info text-dark p-3">1 Ay İçinde (Açık mavi)</span>
    <span class="badge bg-light text-dark p-3">Daha Fazla Süre (Varsayılan)</span>
  </div>
</div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <tableheader @OrderBy="Filter.OrderBy = $event , Get()" :Data='APPLICATION_TYPE == 1 ? [ 
                        { "Takipno": "Takip No" }, 
                        { "Baslik": "Başlık" }, 
                        { "Uygulama": "Uygulama" }, 
                        { "Olusturan": "Talep Sahibi" }, 
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" }, 
                        { "Taleptip": "Talep Tipi" }, 
                        { "Atananbirim": "Atanan Birim" }, 
                        { "Durum": "Durum" }, 
                        { "Oncelik": "Öncelik" }, 
                        { "Destekoncelikid": "Destek Öncelik" }, 
                        { "Created": "Oluşturma Tarihi" }, 
                        { "Isgucu": "İş Gücü" }, 
                        { "Harcananzaman": "Harcanan Zaman" }, 
                        { "": "İşlem" },  
                      ] : [ 
                        { "Takipno": "Takip No" }, 
                        { "Baslik": "Başlık" },  
                        { "Olusturan": "Talep Sahibi" }, 
                        { "Tahminibitis": "Tahmini Bitiş Tarihi" }, 
                        { "Taleptip": "Talep Tipi" }, 
                        { "Atananbirim": "Atanan Birim" }, 
                        { "Durum": "Durum" }, 
                        { "Oncelik": "Öncelik" }, 
                        { "Destekoncelikid": "Destek Öncelik" }, 
                        { "Created": "Oluşturma Tarihi" }, 
                        { "": "İşlem" },  
                      ]' />

                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id" :class="Data.Durum != 'Tamamlandı' ? getRowClass(Data.Tahminibitis) : ''">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td v-if="APPLICATION_TYPE == 1">{{ Data.Uygulama }}</td>
                      <td>{{ Data.Olusturan }}</td> 
                      <td>{{ Data.Tahminibitis != null ? formatDateTable(Data.Tahminibitis) : '' }}</td>
                      <td>{{ Data.Taleptip }}</td>
                      <td>{{ Data.Atananbirim }}</td>
                      <td>{{ Data.Durum }}</td>
                      <td>{{ Data.Oncelik }}</td> 
                      <td>{{ Data.Destekoncelik }}</td> 
                      <td>{{ Data.Created != null ? formatDateTable(Data.Created) : '' }}</td>
                      <td v-if="APPLICATION_TYPE == 1">{{ Data.Isgucu }}</td>
                      <td v-if="APPLICATION_TYPE == 1"> 
                         <b-form-input v-model="Data.Harcananzaman" type="number" @blur="HarcananZaman(Data)"></b-form-input>
                      </td>
                      <td>
                        <div class=" 
                            action-is
                            w-100 
                            d-flex
                            justify-content-center
                            align-items-center
                          ">
                          <b-button-group>
                            <b-button v-if="FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '10').id  == Data.Durumid"
                            v-b-tooltip.hover title="Kabul Et" variant="success" @click="Islemde(Data)"><i
                                class="fas fa-check"></i></b-button>
                                
                                <b-button v-if="FormDataType.Durumid.ComboDataArray.find(item => item.Kod === '10').id  == Data.Durumid"
                                  v-b-tooltip.hover title="İade Et" variant="warning"
                                 @click="BirimeIade(Data)"> <i
                                  class="fa fa-share"></i> </b-button>
                          
                            <b-button v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Id)"><i
                                class="far fa-eye"></i></b-button>
                            <b-button v-b-tooltip.hover title="Düzenle" variant="success" v-b-modal.tlptalep v-if="0"
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                            <b-button variant="danger" v-b-tooltip.hover title="Sil" v-if="0"
                              @click="Delete('tlptalep', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br /><b>Toplam Kayıt Sayısı: {{ Page.PageDataSize }}</b>
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"   
                  :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </Layout>
  </Loader>
</template>
